import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import styles from "./Profile.module.css";
import ProfileImages from "./ProfileImages";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { CiLinkedin } from "react-icons/ci";
import { PiAddressBookLight } from "react-icons/pi";
import { PiChairLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getAllBranch,
  getProfile,
  requestEmailChsanges,
  updateProfile,
  veryfyEmailChanges,
} from "../../redux/profile/profileSlice";
import { useEffect, useState } from "react";
import { PiUserLight } from "react-icons/pi";
import { BsGenderAmbiguous } from "react-icons/bs";
import { gender } from "../../utils/const2";
import OTPInput from "react-otp-input";
import { Icon } from "@iconify/react/dist/iconify.js";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px  ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const ProfileUpdateDrawer = ({ handleClose, show, type, userDetails }) => {
  const [open, setOpen] = useState(false);
  const [mobile_otp, setMobile_otp] = useState("");
  const [errors, setErrors] = useState({});

  const [profileImage, setProfileImage] = useState(null);
  const [banner, setBanner] = useState(null);
  const profileStatus = useSelector((state) => state.profile.status);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const branchData = useSelector((state) => state.profile?.branchData);
  const [selectedBranchIds, setSelectedBranchIds] = useState([]);

  const formik = useFormik({
    initialValues: {
      full_name: userDetails?.full_name || "",
      user_id: userDetails?.username || "",
      mobile_no: userDetails?.mobile_no || "",
      designation: userDetails?.designation || "",
      mobile_no: userDetails?.mobile_no || "",
      email: userDetails?.email || "",
      company_name: userDetails?.company_name || "",
      gender: userDetails?.gender || "",
      experience: userDetails?.experience || "",
      company_website: userDetails?.company_website || "",
      linkedin_profile_url: userDetails?.linkedin_profile_url || "",
      profile_picture: userDetails?.profile_picture || profileImage,
      banner_picture: userDetails?.banner_picture || banner,
      company_location: userDetails?.company_branch[0]?.company_location || "",
      company_branch: [],
    },
    validationSchema: Yup.object({
      designation: Yup.string().required("Designation is required"),
      mobile_no: Yup.string().required("Mobile Number is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      company_name: Yup.string().required("Company Name is required"),
      gender: Yup.string().required("Gender is required"),
      experience: Yup.string().required("Experience is required"),
      company_website: Yup.string().required("Company Website is required"),
      // linkedin_profile_url: Yup.string().required(
      //   "Linkdin Profile is required"
      // ),
    }),
    onSubmit: (values) => {
      const formattedValues = {
        ...values,
        company_branch: selectedBranchIds,
      };
      if (values.email !== userDetails?.email) {
        let userData = { new_email: values.email };
        dispatch(requestEmailChsanges(userData));

        dispatch(updateProfile(formattedValues));
      } else {
        dispatch(updateProfile(formattedValues));
      }
    },
  });

  const handleChange = (code) => setMobile_otp(code);

  useEffect(() => {
    if (banner) {
      formik.setFieldValue("banner_picture", banner);
    }
    if (profileImage) {
      formik.setFieldValue("profile_picture", profileImage);
    }
  }, [profileImage, banner]);

  useEffect(() => {
    if (userDetails) {
      setProfileImage(userDetails?.profile_picture);
      setBanner(userDetails?.banner_picture);
    }
  }, [userDetails]);

  useEffect(() => {
    if (formik.values.email !== userDetails?.email) {
    } else if (profileStatus === "update_profile_succeeded") {
      dispatch(getProfile());
      handleClose();
    }
  }, [profileStatus]);

  const validate = () => {
    const errors = {};
    if (!mobile_otp) errors.mobile_otp = "Otp is required";
    if (mobile_otp.length !== 6) errors.mobile_otp = "Otp should be 6 digit";
    return errors;
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOnClickVerifyOtp = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length === 0) {
      let userData = { otp: mobile_otp };
      dispatch(veryfyEmailChanges(userData));
    } else {
      setErrors(errors);
    }
  };

  // const handleOnClickResendOtp = () => {
  //   dispatch(resendOtp({ email: userData && userData?.user?.email }));
  // };

  useEffect(() => {
    if (profileStatus === "request_email_changes_succeeded") {
      handleClickOpen();
    } else if (profileStatus === "verify_email_succeeded") {
      handleCloseModal();
      dispatch(getProfile());
      navigate(-1);
    }
  }, [profileStatus]);

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      formik.setFieldValue("mobile_no", value);
    }
  };

  useEffect(() => {
    if (userDetails?.designation === "") {
      if (userDetails?.recruiter_type === "IT_RECRUITER") {
        formik.setFieldValue("designation", "IT Recruiter");
      } else {
        formik.setFieldValue("designation", "Bench Sales Recruiter");
      }
    }
  }, [userDetails]);

  useEffect(() => {
    dispatch(getAllBranch());
  }, []);

  const handleToggle = (branchId) => {
    setSelectedBranchIds(
      (prev) =>
        prev.includes(branchId)
          ? prev.filter((id) => id !== branchId) // Remove
          : [...prev, branchId] // Add
    );
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "60%",
        // padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "end",
        }}
      >
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
            marginRight: "20px",
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Box>
          <ProfileImages
            profileImage={profileImage}
            setProfileImage={setProfileImage}
            banner={banner}
            setBanner={setBanner}
            userDetails={userDetails}
          />

          <form onSubmit={formik.handleSubmit}>
            {/* {profileStatus === "loading" ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 230,
                }}
              >
                <CircularProgress size={30} color="info" />
              </Box>
            ) : ( */}
            <Grid container className={styles.candidate_field_section}>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiIdentificationCardLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="User ID"
                  variant="standard"
                  type="text"
                  name="user_id"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.user_id}
                  sx={fieldStyle}
                  disabled={true}
                />
                {formik.touched.user_id && formik.errors.user_id ? (
                  <div className={styles.error}>{formik.errors.user_id}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Name"
                  variant="standard"
                  type="text"
                  name="full_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.full_name}
                  sx={fieldStyle}
                  disabled={true}
                />
                {formik.touched.full_name && formik.errors.full_name ? (
                  <div className={styles.error}>{formik.errors.full_name}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <BsGenderAmbiguous
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  select
                  id="standard-basic"
                  label="Gender"
                  variant="standard"
                  type="text"
                  name="gender"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.gender}
                  sx={fieldStyle}
                  disabled={true}
                >
                  {gender.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {formik.touched.gender && formik.errors.gender ? (
                  <div className={styles.error}>{formik.errors.gender}</div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiChairLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Designation"
                  variant="standard"
                  type="text"
                  name="designation"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.designation}
                  sx={fieldStyle}
                />
                {formik.touched.designation && formik.errors.designation ? (
                  <div className={styles.error}>
                    {formik.errors.designation}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiAddressBookLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Experience"
                  variant="standard"
                  type="text"
                  name="experience"
                  // onChange={formik.handleChange}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Keep only numeric input
                    formik.setFieldValue("experience", rawValue);
                  }}
                  onBlur={formik.handleBlur}
                  // value={formik.values.experience}
                  value={
                    formik.values.experience
                      ? `${formik.values.experience} ${
                          formik.values.experience > 1 ? "Years" : "Year"
                        }`
                      : ""
                  }
                  sx={fieldStyle}
                  disabled
                />
                {formik.touched.experience && formik.errors.experience ? (
                  <div className={styles.error}>{formik.errors.experience}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Work Phone No"
                  variant="standard"
                  type="text"
                  name="mobile_no"
                  onChange={handleMobileNoChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.mobile_no}
                  sx={fieldStyle}
                  disabled
                />
                {formik.touched.mobile_no && formik.errors.mobile_no ? (
                  <div className={styles.error}>{formik.errors.mobile_no}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMailboxLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Work Email ID"
                  variant="standard"
                  type="text"
                  name="email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  sx={fieldStyle}
                  disabled
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className={styles.error}>{formik.errors.email}</div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBuildingOfficeLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Company"
                  variant="standard"
                  type="text"
                  name="company_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company_name}
                  sx={fieldStyle}
                  disabled
                />
                {formik.touched.company_name && formik.errors.company_name ? (
                  <div className={styles.error}>
                    {formik.errors.company_name}
                  </div>
                ) : null}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBuildingOfficeLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Company Website"
                  variant="standard"
                  type="text"
                  name="company_website"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company_website}
                  sx={fieldStyle}
                  disabled
                />
                {formik.touched.company_website &&
                formik.errors.company_website ? (
                  <div className={styles.error}>
                    {formik.errors.company_website}
                  </div>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiLinkedin style={{ fontSize: "25px", color: "#3f475a" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="LinkedIn URL"
                  variant="standard"
                  type="text"
                  name="linkedin_profile_url"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.linkedin_profile_url}
                  sx={fieldStyle}
                />
                {/* {formik.touched.linkedin_profile_url &&
                formik.errors.linkedin_profile_url ? (
                  <div className={styles.error}>
                    {formik.errors.linkedin_profile_url}
                  </div>
                ) : null} */}
              </Grid>
            </Grid>
            {/* // )} */}
          </form>

          <Box sx={{ marginTop: "30px" }}></Box>
          {/* {branchData?.map((branch) => {
            const workInBranchIds = userDetails?.company_branch?.map(
              (branch) => branch.branch_id
            );
            const isWorkIn = workInBranchIds?.includes(branch.branch_id);
            const isSelected = selectedBranchIds?.includes(branch.branch_id);
            return (
              <Box className={styles.BranchCard}>
                <span>
                  <Typography>
                    <b>{branch?.division}</b>
                  </Typography>
                  <Typography>
                    <b>
                      {branch?.plot_number}, {branch?.landmark} {branch?.state}{" "}
                      {branch?.pincode}
                    </b>
                  </Typography>
                  <Typography sx={{ marginTop: "7px" }}>
                    Created by Ramesh Kuhani of Ranchi Branch{" "}
                  </Typography>
                </span>

                <span>
                  <button
                    onClick={() => handleToggle(branch.branch_id)}
                    style={{
                      padding: "8px 25px",
                      backgroundColor: isSelected ? "#c0392b" : "#28a745",
                      color: "white",
                      border: "none",
                      cursor: "pointer",
                    }}
                    className={styles.BranchCard_button}
                  >
                    {isSelected ? "Remove" : "Available"}
                  </button>
                </span>
              </Box>
            );
          })} */}

          {branchData?.map((branch) => {
            const workInBranchIds = userDetails?.company_branch?.map(
              (branch) => branch.branch_id
            );
            const isWorkIn = workInBranchIds?.includes(branch.branch_id);
            const isSelected = selectedBranchIds?.includes(branch.branch_id);

            const getButtonLabel = () => {
              if (isWorkIn) return "Work In";
              return isSelected ? "Remove" : "Available";
            };

            const getBackgroundColor = () => {
              if (isWorkIn) return "#3856a6";
              return isSelected ? "#c0392b" : "#28a745";
            };

            const getCursor = () => {
              return isWorkIn ? "auto" : "pointer";
            };

            return (
              <Box className={styles.BranchCard} key={branch.branch_id}>
                <span>
                  <Typography>
                    <b>{branch?.division}</b>
                  </Typography>
                  <Typography>
                    <b>
                      {branch?.plot_number}, {branch?.landmark} {branch?.state}{" "}
                      {branch?.pincode}
                    </b>
                  </Typography>
                  <Typography sx={{ marginTop: "7px" }}>
                    Created by{" "}
                    {branch?.created_by_details !== null &&
                      branch?.created_by_details !== undefined &&
                      branch?.created_by_details?.profiles[0]?.fullName}{" "}
                  </Typography>
                </span>

                <span>
                  <button
                    onClick={() => {
                      if (!isWorkIn) handleToggle(branch.branch_id);
                    }}
                    style={{
                      padding: "8px 25px",
                      backgroundColor: getBackgroundColor(),
                      color: "white",
                      border: "none",
                      cursor: getCursor(),
                    }}
                    className={styles.BranchCard_button}
                    disabled={isWorkIn}
                  >
                    {getButtonLabel()}
                  </button>
                </span>
              </Box>
            );
          })}

          {/* 3856a6 */}
          <Box className={styles.profile_edit_btns}>
            <button
              onClick={formik.handleSubmit}
              style={profileStatus === "loading" ? { padding: "7px 40px" } : {}}
            >
              {profileStatus === "loading" ? (
                <CircularProgress size={12} sx={{ color: "#fff" }} />
              ) : (
                "Save Changes"
              )}
            </button>
          </Box>
          <Dialog
            fullScreen={fullScreen}
            open={open}
            // onClose={handleCloseModal}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              id="responsive-dialog-title"
              sx={{ color: "#3856a6", marginTop: "10px" }}
            >
              {"Verify OTP!"}
            </DialogTitle>
            <DialogContent>
              <span>
                <OTPInput
                  value={mobile_otp}
                  onChange={handleChange}
                  numInputs={6}
                  separator={<span style={{ width: "8px" }}></span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    width: "54px",
                    height: "54px",
                    fontSize: "16px",
                    color: "#000",
                    fontWeight: "500",
                    caretColor: "blue",
                    margin: "10px",
                  }}
                  focusStyle={{
                    border: "1px solid #CFD3DB",
                    outline: "none",
                  }}
                />
                {errors.mobile_otp && (
                  <p className="login_error">{errors.mobile_otp}</p>
                )}
              </span>
              {/* <p
                style={{
                  float: "right",
                  textDecoration: "underline",
                  color: " #3856a6",
                  cursor: "pointer",
                }}
                onClick={handleOnClickResendOtp}
              >
                Resend otp
              </p> */}
            </DialogContent>
            <DialogActions className="forgot_password_modal_btns">
              <Button onClick={handleOnClickVerifyOtp}>
                {profileStatus === "loading" ? (
                  <CircularProgress size={12} sx={{ color: "#fff" }} />
                ) : (
                  "Submit"
                )}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ProfileUpdateDrawer;
